import { useState } from "react";
import { taskService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";

export const useIssueTemplateOrderTemplatesViewModel = ({
  issueTemplateId,
  stateManager,
}) => {
  const [issueTemplateOrderTemplates, setIssueTemplateOrderTemplates] =
    useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);
  const [orderTemplates, setOrderTemplates] = useState([]);

  const getOrderTemplates = () => {
    return stateManager.run(async () => {
      const response = await taskService.orderTemplates.getAll();
      if (response.status === HTTP_STATUSES.OK) {
        return response.data;
      }
      return [];
    });
  };

  const getIssueTemplateOrderTemplates = () => {
    return stateManager.run(async () => {
      const response = await taskService.issueTemplateOrderTemplateMaps.getAll({
        filters: {
          issueTemplateId: { type: "guid", value: issueTemplateId },
        },
      });
      if (response.status === HTTP_STATUSES.OK) {
        return response.data;
      }
      return [];
    });
  };

  const mapOrderTemplates = (
    issueTemplateOrderTemplatesResponse,
    orderTemplatesResponse
  ) => {
    const existingIssueTemplateOrderTemplates =
      issueTemplateOrderTemplatesResponse.map((val) => val.orderTemplateId);
    const filteredOrderTemplates = orderTemplatesResponse.filter(
      (orderTemplate) =>
        !existingIssueTemplateOrderTemplates.includes(orderTemplate.id)
    );
    setOrderTemplates(
      filteredOrderTemplates.map((val) => ({
        ...val,
        label: val.name,
        value: val.id,
      }))
    );
  };

  const mapIssueTemplatesOrderTemplates = (
    issueTemplateOrderTemplatesResponse,
    orderTemplatesResponse
  ) => {
    const orderTemplatesMap = orderTemplatesResponse.reduce(
      (acc, orderTemplate) => {
        acc[orderTemplate.id] = orderTemplate;
        return acc;
      },
      {}
    );
    const mappedIssueTemplateOrderTemplates =
      issueTemplateOrderTemplatesResponse.map((val) => ({
        ...val,
        id: val.orderTemplateId,
        name: orderTemplatesMap[val.orderTemplateId]?.name,
      }));
    setIssueTemplateOrderTemplates(mappedIssueTemplateOrderTemplates);
  };

  const getAllData = () => {
    return stateManager.run(async () => {
      const orderTemplatesResponse = await getOrderTemplates();
      const issueTemplateOrderTemplatesResponse =
        await getIssueTemplateOrderTemplates();
      mapOrderTemplates(
        issueTemplateOrderTemplatesResponse,
        orderTemplatesResponse
      );
      mapIssueTemplatesOrderTemplates(
        issueTemplateOrderTemplatesResponse,
        orderTemplatesResponse
      );
    });
  };

  const removeIssueTemplateOrderTemplate = ({
    orderTemplateId,
    issueTemplateId,
    modifiedOn,
  }) => {
    return stateManager.run(async () => {
      const response = await taskService.issueTemplateOrderTemplateMaps.delete({
        orderTemplateId,
        issueTemplateId,
        modifiedOn,
      });
      if (response.status === HTTP_STATUSES.OK) {
        getAllData();
      }
    });
  };

  const addIssueTemplateOrderTemplate = ({ orderTemplateId }) => {
    return stateManager.run(async () => {
      const response = await taskService.issueTemplateOrderTemplateMaps.create({
        data: {
          orderTemplateId,
          issueTemplateId,
        },
      });
      if (response.status === HTTP_STATUSES.OK) {
        getAllData();
      }
    });
  };

  return {
    selectedItem,
    setSelectedItem,
    isOpenDeleteModal,
    setIsOpenDeleteModal,
    orderTemplates,
    getOrderTemplates,
    issueTemplateOrderTemplates,
    getAllData,
    removeIssueTemplateOrderTemplate,
    addIssueTemplateOrderTemplate,
  };
};
